export default "__VITE_ASSET__D0GSzVA8__"